<template>
  <v-container fluid class="pa-0" style="height: inherit !important;">
    <UnLicencedAccess v-if="notLicenced"></UnLicencedAccess>
    <UnAuthorizedAccess v-else-if="BrokenPermit"></UnAuthorizedAccess>
    <slot v-else></slot>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import NavMixin from "@/helpers/Mixins/NavMixin.js";
import UnAuthorizedAccess from "@/views/landingpages/UnAuthorizedAccess.vue";
import UnLicencedAccess from "@/views/landingpages/UnLicencedAccess.vue";

export default {
  name: "NavigationAuthorizer",
  props: {},
  components: {
    UnAuthorizedAccess,
    UnLicencedAccess,
  },
  mixins: [NavMixin, clientAPI],

  data() {
    return {};
  },

  mounted() {
    this.parseNode();
    this.checkAuthorization();
  },

  methods: {
    parseNode() {
      var node = this.$route;
      this.$store.dispatch("navstore/setCurrentNode", node);
    },

    checkAuthorization() {
      var authorized = this.checkUserAuthorizationForNode(this.node);
      this.$store.dispatch("navstore/setBrokenPermission", !authorized);
    },
  },

  computed: {
    userInfo() {
      return this.$store.getters["userInfo"];
    },

    BrokenPermit() {
      return this.$store.getters["navstore/BrokenPermission"];
    },

    node() {
      return this.$store.getters["navstore/CurrentNode"];
    },

    notLicenced() {
      return !this.checkIfLicencedByKey(this.node?.meta?.licenseEnabled);
    },
    notFeatureEnabled() {
      return !this.checkIfFeatureEnabledByKey(this.node?.meta?.featureEnabled);
    },
  },

  watch: {
    $route: function () {
      this.parseNode();
    },
    "userInfo.UserTypeId": function () {
      this.checkAuthorization();
      //reconstruct nav tree
    },
  },
};
</script>
